import React from 'react'
import {
	Container,
	ListItem,
	Section,
	UnorderedList,
	Text,
	Link,
	ChipContainer,
	Chip,
	Small,
	CheckboxContainer,
} from './DeleteForm.styles'
import {
	InputField,
	InputPhoneNumber,
	TextArea,
} from '@welbe/web-design-system'
import { DeleteAccountProps } from 'Views/DeleteAccount/DeleteAccount.types'

type DeleteFormProps = {
	hasAgreed: boolean
	payload: DeleteAccountProps
	onAgree: (state: boolean) => void
	onChange: (payload: DeleteAccountProps) => void
}

const ChipOptions = [
	'Privacidad de datos',
	'Es difícil de usar',
	'Fallas en la App',
	'Mal soporte',
	'Tengo otra cuenta',
	'No estoy satisfecho',
	'Otro motivo',
]

export const DeleteForm = ({
	payload,
	hasAgreed,
	onAgree,
	onChange,
}: DeleteFormProps) => {
	const [type, setType] = React.useState('email')
	const handleSelect = (chip: string) => {
		if (payload?.reasons?.includes(chip)) {
			onChange?.({
				...payload,
				reasons: payload?.reasons?.filter(item => item !== chip),
			})
			return
		}

		onChange?.({
			...payload,
			reasons: [...(payload?.reasons || []), chip],
		})
	}

	return (
		<Container>
			<Section gap="16px">
				<Section gap="32px">
					<Text variant="large">
						Al borrar tu cuenta perderás definitivamente:
					</Text>

					<UnorderedList>
						<ListItem>Acceso a tu membresía Welbe</ListItem>
						<ListItem>Datos de tu historial médico</ListItem>
						<ListItem>Historial de consultas médicas</ListItem>
						<ListItem>Resultados de laboratorio </ListItem>
					</UnorderedList>
				</Section>
				<Text variant="small">
					Seguridad y manejo de la información{' '}
					<Link
						variant="small"
						onClick={() =>
							window.open('https://avisoprivacidad.welbecare.com/', '_blank')
						}
					>
						Conoce los detalles en el Aviso de Privacidad
					</Link>
				</Text>
				<Text variant="large">
					Ingresa tu correo electrónico para recibir un código y verificar que
					la cuenta te pertenece
				</Text>
				{type === 'email' ? (
					<InputField
						label="Correo electrónico *"
						placeholder="Correo electrónico"
						value={payload?.email}
						onChange={value =>
							onChange?.({ ...payload, email: value || '', phone: '' })
						}
						className="input-field"
					/>
				) : (
					<InputPhoneNumber
						label="Número de teléfono  *"
						placeholder="Número de teléfono"
						value={payload?.phone}
						onChange={(value: any) =>
							onChange?.({ ...payload, phone: value || '', email: '' })
						}
					/>
				)}
				<Link
					variant="small"
					onClick={() => {
						setType(type => (type === 'email' ? 'phone' : 'email'))
						onChange?.({ ...payload, phone: '', email: '' })
					}}
				>
					{type === 'email'
						? '¿Te registraste con tu número telefónico?'
						: '¿Te registraste con tu correo electrónico?'}
				</Link>
				<Text variant="small">
					Antes de borrar tu cuenta, cuéntanos el motivo, tu respuesta nos
					ayudará a mejorar.
				</Text>
			</Section>

			<Section gap="32px">
				<ChipContainer>
					{ChipOptions.map(chip => (
						<Chip
							key={chip}
							active={payload?.reasons?.includes(chip)}
							onClick={() => handleSelect(chip)}
						>
							{chip}
						</Chip>
					))}
				</ChipContainer>
				<TextArea
					label="Cuéntanos un poco mas"
					placeholder="Escriba aquí el motivo de otros asuntos..."
					value={payload?.comments || ''}
					handleChange={value => onChange?.({ ...payload, comments: value })}
				/>
				<Small>
					Temporalmente guardaremos
					<Small
						bold
						cursor="pointer"
						onClick={() =>
							window.open(
								'https://terminosycondiciones.welbecare.com',
								'_blank',
							)
						}
					>
						{' '}
						algunos de tus datos
					</Small>{' '}
					para cumplir con la regulaciones que nos lo exigen. No te preocupes,
					los eliminaremos tan pronto sea posible. Para continuar necesitamos
					que estés de acuerdo con esto.
				</Small>
				<CheckboxContainer>
					<input
						style={{ transform: 'scale(1.5)' }}
						type="checkbox"
						id="accept"
						checked={hasAgreed}
						onChange={e => onAgree(e.target.checked)}
					/>
					<label htmlFor="accept">Estoy de acuerdo</label>
				</CheckboxContainer>
			</Section>
		</Container>
	)
}
